import React from 'react';

import { Grid } from '@material-ui/core';
import moment from 'moment';

import { useStylesMUI } from '../../../styles/home/style';
import { TemplateReports } from '../../atomic/templates/TemplateReports';
import { SelectValidatorGeneric } from '../../atomic/atoms/Select';
import { useTotem } from '../../../hooks/useCases/useTotem';
import { useEffect } from 'react';

export const SolicitudesAfiliadosReports = () => {
    const classes = useStylesMUI();
    const totem = useTotem();

    useEffect(() => { totem.get.recepciones() }, []);

    return (
        <Grid container justify="center" className={classes.page}>
            <Grid item xs={12}>
                <TemplateReports 
                    handleSubmit={(data) => { totem.files.solicitudesAfiliados.get(data) }}
                    handleExcel={(data) => { totem.files.solicitudesAfiliados.excel(data) }}
                    handlePdf={(data) => { totem.files.solicitudesAfiliados.pdf(data) }}
                    title= "Reporte - Solicitudes Afiliados"
                    disabledReport={totem.data.solicitudesAfiliados.length === 0}
                    behindDates={{
                        value: { idTipoSolicitud: 1, idRecepcion: 0 },
                        Component: (formValues, setFormValues) => (
                            <Grid container spacing={0}>
                                <Grid item xs={6}>
                                    <SelectValidatorGeneric 
                                        style={{border: "1px solid #ddd", borderRadius: 0}}
                                        label="Tipo Solicitud"
                                        name="idTipoSolicitud"
                                        value={formValues?.idTipoSolicitud}
                                        onChange={(e) => { setFormValues({idTipoSolicitud: e.target.value}) }}
                                        menuItems={[
                                            {
                                                value: 1,
                                                label: "Todas las Solicitudes"
                                            },
                                            {
                                                value: 2,
                                                label: "Solicitudes Pendiente"
                                            },
                                            {
                                                value: 3,
                                                label: "Solicitudes Confirmadas"
                                            },
                                        ]}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <SelectValidatorGeneric 
                                        style={{border: "1px solid #ddd", borderRadius: 0}}
                                        label="Recepción"
                                        name="idRecepcion"
                                        value={formValues?.idRecepcion}
                                        onChange={(e) => { setFormValues({idRecepcion: e.target.value}) }}
                                        menuItems={[
                                            {
                                                value: 0,
                                                label: "Todas las Recepciones"
                                            },
                                            ...totem.data.recepciones.map((item) => ({
                                                value: item.id,
                                                label: item.descripcion
                                            })),
                                        ]}
                                    />
                                </Grid>
                            </Grid>
                        )
                    }}
                    list={totem.data.solicitudesAfiliados}
                    columns={[
                        {
                            id: "id",
                            label: "N° Solicitud"
                        },
                        {
                            id: "recepcion.descripcion",
                            label: "Recepción"
                        },
                        {
                            id: "afiliado.nombreApellido",
                            label: "Afiliado"
                        },
                        {
                            id: "afiliado.carnet",
                            label: "Carnet Afiliado"
                        },
                        {
                            label: "Fecha Solicitud",
                            customBody: (item) => moment(item.fechaSolicitud).format("DD/MM/YYYY - HH:mm")
                        },
                        {
                            id: "opcion.descripcion",
                            label: "Opción"
                        },
                        {
                            id: "subOpcion.descripcion",
                            label: "Sub Opción"
                        },
                        {
                            label: "Fecha Confirmación",
                            customBody: (item) => !!item.fechaConfirmacion ? moment(item.fechaConfirmacion).format("DD/MM/YYYY - HH:mm") : ""
                        },
                        {
                            id: "usuarioConfirmacion.userName",
                            label: "Usuario Confirmación"
                        }
                    ]}
                />
            </Grid>
        </Grid>
    )
}
